export default {
  DETAIL: 'DETAIL',
  LIVE: 'LIVE',
  VOD: 'VOD',
};
